import React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { Config } from "config";
import { useTranslation } from "react-i18next";
import { getCorilusPassportURL } from "store/actions/user-context.actions";
import Button from "@cc/react-components/Button";
import Brand from "@cc/react-components/Brand";

export interface Props
  extends React.HTMLAttributes<HTMLElement>,
    RouteComponentProps {
  /** CareConnect visit configuration */
  config: Config;
}

const redirectCorilusPassport = (config: Config) => {
  const url = getCorilusPassportURL(config);
  window.location.replace(url);
};

const LoginHome = ({ config, history, ...props }: Props) => {
  const [t] = useTranslation();
  return (
    <div className="vh-100 d-flex align-items-center justify-content-center">
      <div>
        <Brand application="Visit" mobile animated />
        <div className="text-center mt-4">
          <Button
            variant="primary"
            onClick={() => redirectCorilusPassport(config)}
            size="lg"
          >
            {t("login.start")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default connect(null, null)(LoginHome);
